import { FC } from 'react';

type Props = {
  isDisablePrevButtons: boolean;
  isDisableNextButtons: boolean;
  toFirstPage: () => void;
  toNextPage: () => void;
  toLastPage: () => void;
  toPreviousPage: () => void;
};

const PaginationButtons: FC<Props> = ({
  isDisablePrevButtons,
  isDisableNextButtons,
  toFirstPage,
  toNextPage,
  toLastPage,
  toPreviousPage,
}: Props) => (
  <div className="p-paginator">
    <button
      type="button"
      className={`${
        isDisablePrevButtons ? 'p-disabled' : ''
      } p-paginator-first p-paginator-element p-link`}
      disabled={isDisablePrevButtons}
      onClick={toFirstPage}
    >
      <span className="p-paginator-icon pi pi-angle-double-left" />
    </button>
    <button
      type="button"
      className={`${
        isDisablePrevButtons ? 'p-disabled' : ''
      } p-paginator-first p-paginator-element p-link`}
      disabled={isDisablePrevButtons}
      onClick={toPreviousPage}
    >
      <span className="p-paginator-icon pi pi-angle-left" />
    </button>
    <button
      type="button"
      className={`${
        isDisableNextButtons ? 'p-disabled' : ''
      } p-paginator-first p-paginator-element p-link`}
      disabled={isDisableNextButtons}
      onClick={toNextPage}
    >
      <span className="p-paginator-icon pi pi-angle-right" />
    </button>
    <button
      type="button"
      className={`${
        isDisableNextButtons ? 'p-disabled' : ''
      } p-paginator-first p-paginator-element p-link`}
      disabled={isDisableNextButtons}
      onClick={toLastPage}
    >
      <span className="p-paginator-icon pi pi-angle-double-right" />
    </button>
  </div>
);

export default PaginationButtons;
